// src/pages/app/SettingsPage.jsx
import React from 'react';
import DashboardLayout from '../../layouts/DashboardLayout'; 

const SettingsPage = () => {

    const SettingToggle = ({ label, description, defaultChecked }) => (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '15px 0', borderBottom: '1px solid #eee' }}>
            <div>
                <h4 style={{ margin: '0', fontSize: '1rem', color: 'var(--color-navy)' }}>{label}</h4>
                <p style={{ margin: '0', fontSize: '0.85rem', color: 'var(--color-gray-medium)' }}>{description}</p>
            </div>
            {/* Simple checkbox placeholder for a toggle switch */}
            <input type="checkbox" defaultChecked={defaultChecked} style={{ width: '20px', height: '20px' }} />
        </div>
    );


    return (
        <DashboardLayout>
            <h1 className="dashboard-page-title">Settings</h1>
            <p className="dashboard-page-subtitle">Control your notifications, privacy, and account security.</p>
            
            {/* Notifications Widget */}
            <div className="widget" style={{ marginBottom: '30px' }}>
                <h3 className="widget-title">Notification Preferences</h3>
                <SettingToggle 
                    label="Email Notifications" 
                    description="Receive weekly digests and important alerts via email." 
                    defaultChecked={true}
                />
                <SettingToggle 
                    label="Push Notifications" 
                    description="Get instant alerts for new posts in your primary chatroom." 
                    defaultChecked={true}
                />
                <SettingToggle 
                    label="Promotional Updates" 
                    description="Receive updates about new features and platform news." 
                    defaultChecked={false}
                />
            </div>

            {/* Security Widget */}
            <div className="widget">
                <h3 className="widget-title">Account Security</h3>
                <p style={{ fontSize: '0.9rem', color: 'var(--color-gray-dark)' }}>
                    Your account is secure. Last login was 3 minutes ago from NYC, NY.
                </p>
                <div style={{ marginTop: '20px' }}>
                    <button className="auth-button auth-google-button" style={{ width: '250px', padding: '8px', fontSize: '14px' }}>Enable Two-Factor Auth</button>
                    <button className="auth-button auth-google-button" style={{ width: '250px', padding: '8px', fontSize: '14px', marginLeft: '10px' }}>Review Activity Log</button>
                </div>
            </div>
        </DashboardLayout>
    );
};

export default SettingsPage;